'use client';

import {
    Box,
    Grid,
    Typography,
    Chip
} from "@mui/material";
import { useTranslations } from "next-intl";

const AirxpressEx = () => {
    const t = useTranslations("ServicePage.airxpress_ex");
    return (
        <Box sx={{ py: { xs: 8, md: 12 }, px: 2, backgroundColor: "#ffffff" }}>
            <Box sx={{ maxWidth: "lg", margin: "auto", textAlign: "center", mb: 8 }}>
                <span className="inline-block bg-[#F15859] text-white text-xs font-bold px-6 py-1.5 rounded-full mb-6 shadow-sm">
                    {t('chip')}
                </span>
                <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: "#132c4b", mb: 2 }}>
                    {t('title')}
                </Typography>
                <Typography variant="body1" sx={{ color: "#64748b" }}>
                    {t('description')}
                </Typography>
            </Box>

            <Grid container spacing={4} sx={{ maxWidth: "lg", margin: "auto" }}>
                {/* Left Column: Web Operation Plan */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box sx={{
                        backgroundColor: "white",
                        borderRadius: "24px",
                        border: "1px solid #e2e8f0",
                        p: 4,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <Box sx={{ textAlign: "center", mb: 4 }}>
                            <Chip label={t('web_chip')} size="small" sx={{ mb: 2, backgroundColor: "#e2e8f0", fontWeight: "bold" }} />
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 1 }}>
                                {t('web_title')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>
                                {t('web_caption')}
                            </Typography>
                        </Box>

                        {/* Card: Percentage Fee */}
                        <Box sx={{
                            backgroundColor: "#132c4b",
                            border: "1px solid #e2e8f0",
                            borderRadius: "16px",
                            p: 3,
                            mb: 3,
                            color: "#fff"
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="caption" sx={{ fontWeight: "bold" }}>{t('performance_label')}</Typography>
                                <Chip label={t('recommended_chip')} size="small" sx={{ backgroundColor: "#F15859", color: "white", fontSize: "0.7rem", height: "20px" }} />
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#fff", mb: 1, textAlign: "left" }}>
                                {t('web_price')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#fff", display: 'block', mb: 3, textAlign: "left" }}
                                dangerouslySetInnerHTML={{ __html: t.raw('web_desc') }}
                            />
                        </Box>

                        <Box sx={{ mt: 2, backgroundColor: "#fff7ed", borderRadius: "16px", p: 3 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#c2410c", mb: 1 }}>
                                {t('web_services_title')}
                            </Typography>
                            <ul style={{ paddingLeft: "1.2rem", color: "#c2410c", fontSize: "0.875rem", listStyleType: "disc" }}>
                                <li>{t('web_service_1')}</li>
                                <li>{t('web_service_2')}</li>
                                <li>{t('web_service_3')}</li>
                                <li>{t('web_service_4')}</li>
                                <li>{t('web_service_5')}</li>
                            </ul>
                        </Box>
                    </Box>
                </Grid>

                {/* Right Column: Full Operation Plan */}
                <Grid size={{ xs: 12, md: 6 }}>
                    <Box sx={{
                        backgroundColor: "#ffff",
                        borderRadius: "24px",
                        border: "1px solid #e2e8f0",
                        p: 4,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <Box sx={{ textAlign: "center", mb: 4 }}>
                            <Chip label={t('full_chip')} size="small" sx={{ mb: 2, backgroundColor: "#e2e8f0", fontWeight: "bold" }} />
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 1 }}>
                                {t('full_title')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#64748b" }}>
                                {t('full_caption')}
                            </Typography>
                        </Box>

                        {/* Card: Percentage Fee */}
                        <Box sx={{
                            backgroundColor: "#132c4b",
                            border: "1px solid #e2e8f0",
                            borderRadius: "16px",
                            p: 3,
                            mb: 3,
                            color: "#fff"
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="caption" sx={{ fontWeight: "bold" }}>{t('full_performance_label')}</Typography>
                                <Chip label={t('new_chip')} size="small" sx={{ backgroundColor: "#F15859", color: "white", fontSize: "0.7rem", height: "20px" }} />
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold", color: "#fff", mb: 1, textAlign: "left" }}>
                                {t('full_price')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#fff", display: 'block', mb: 3, textAlign: "left" }}
                                dangerouslySetInnerHTML={{ __html: t.raw('full_desc') }}
                            />
                        </Box>

                        <Box sx={{ mt: 2, backgroundColor: "#fff7ed", borderRadius: "16px", p: 3 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#c2410c", mb: 1 }}>
                                {t('full_services_title')}
                            </Typography>
                            <ul style={{ paddingLeft: "1.2rem", color: "#c2410c", fontSize: "0.875rem", listStyleType: "disc" }}>
                                <li>{t('full_service_1')}</li>
                                <li>{t('full_service_2')}</li>
                                <li>{t('full_service_3')}</li>
                                <li>{t('full_service_4')}</li>
                            </ul>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AirxpressEx;
